import { MutationTree } from 'vuex';
import { orderBy } from 'lodash';

import { ScheduleState, MatchDay, Match } from './models';

export enum Mutations {
  SET_ALL_MATCH_DAYS = 'SET_ALL_MATCH_DAYS',
  SET_MATCHES_FOR_MATCH_DAY = 'SET_MATCHES_FOR_MATCH_DAY',
  SET_MATCH_DAY_ID_FOR_NEW_MATCH = 'SET_MATCH_DAY_ID_FOR_NEW_MATCH',
}

export const mutations: MutationTree<ScheduleState> = {
  [Mutations.SET_ALL_MATCH_DAYS](state, matchDays: MatchDay[]) {
    state.matchDays = orderBy(matchDays, (matchDay) => matchDay.defaultDateTime, 'asc');
  },

  [Mutations.SET_MATCHES_FOR_MATCH_DAY](state, matches: Match[]) {
    if (matches) {
      const matchDayId = matches[0].matchDayId;
      const matchDay: MatchDay = state.matchDays.filter((md) => md.id === matchDayId)[0];
      if (matchDay) {
        const newMatchDay = { ...matchDay, matches };
        const matchDayIndex = state.matchDays.findIndex((md) => md.id === matchDayId);
        state.matchDays.splice(matchDayIndex, 1, newMatchDay);
      }
    }
  },

  [Mutations.SET_MATCH_DAY_ID_FOR_NEW_MATCH](state, matchDayId: number) {
    state.matchDayIdForNewMatch = matchDayId;
  },

};
